import axios from 'axios';

import cfac22 from '../cfac22';
import { getCurrentUserInfo } from 'js/library/services/currentUserInfo';

export default async function getVoucherById(id, extraParams) {
  const userInfo = await getCurrentUserInfo();

  if (!userInfo?.uId) {
    throw new Error('UserInfo unavailable');
  }

  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      const config = {
        method: 'POST',
        url: `${cfac22('API_HOST_V2')}/vouchers/getVoucherById/?voucherId=${id}`,
        headers: {

          'Full-Url': window.location.href
        },
        data: {
          models: extraParams
        }, withCredentials: true
      };

      axios(config).
      then(function (response) {
        resolve(response.data);
      }).
      catch(function (error) {
        reject(error.response.data);
      });
    }).
    catch((error) => {
      reject(error);
    });
  });
}
